// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1chrZ","expireSoon":"styles_expireSoon__1oawB"};